import { Card, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

/**
 * Страница /legal — индекс правовых документов.
 * Простая навигация по разделу для пользователя и для модерации ЮKассы.
 */
export function LegalIndexPage() {
  const items = [
    {
      to: '/legal/terms',
      title: 'Пользовательское соглашение',
      description: 'Условия использования сервиса, права и обязанности сторон.',
    },
    {
      to: '/legal/privacy',
      title: 'Политика конфиденциальности',
      description:
        'Какие персональные данные обрабатываются, на каких основаниях и в каких целях.',
    },
    {
      to: '/legal/requisites',
      title: 'Реквизиты и контакты',
      description: 'Юридические сведения и контакты для обращений.',
    },
    {
      to: '/pricing',
      title: 'Тарифы',
      description: 'Стоимость использования сервиса и условия оплаты.',
    },
  ];

  return (
    <div style={{ maxWidth: 820, margin: '0 auto' }}>
      <Title level={2} style={{ marginTop: 0 }}>
        Правовые документы
      </Title>
      <Paragraph type="secondary" style={{ fontSize: 14 }}>
        Документы, регулирующие использование сервиса RiChat.
      </Paragraph>

      <div
        style={{
          display: 'grid',
          gap: 16,
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          marginTop: 24,
        }}
      >
        {items.map((item) => (
          <Link key={item.to} to={item.to} style={{ textDecoration: 'none' }}>
            <Card
              hoverable
              styles={{ body: { padding: 20 } }}
              style={{ height: '100%' }}
            >
              <Text style={{ fontSize: 15, fontWeight: 500, color: '#1A1A1A' }}>
                {item.title}
              </Text>
              <Paragraph
                type="secondary"
                style={{
                  margin: '6px 0 0',
                  fontSize: 13,
                  lineHeight: 1.5,
                }}
              >
                {item.description}
              </Paragraph>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
